import {FETCH_IC_DATA} from "./index" 

export const setICData = (payload) => {
    return {
      type: FETCH_IC_DATA,
      payload: payload
    };
  };